import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

// This theme's onDocumentReady takes no options (upstream v4 passes `{ once: true }`).
// DOMContentLoaded fires only once, so the behavior is the same.
onDocumentReady(function dispatchPageViewEvent() {
  /** @type {HTMLElement | null} */
  const templateElement = document.querySelector('main[data-template]');
  const template = templateElement?.dataset.template || '';

  // -- Page --
  document.dispatchEvent(
    new PageViewEvent({
      page: {
        template,
        title: document.title,
        url: window.location.href,
      },
    })
  );
});
